import {
    Box,
    Button,
    Grid,
    IconButton,
    InputAdornment,
    SwipeableDrawer,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { getLoadingStatus, getLogo, sendasyncmessage, sendmessage } from "../Redux/Chat/chataction";
import { storage } from "../Config/Storage";
import TypingText from "../Config/Typingtext";
import { useTheme } from "@mui/material/styles";
import "../Config/fontAwesomeConfig";
import { useLocation, useSearchParams } from "react-router-dom"
import LanguageSwitcher from "../Components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import Logo from "../Components/Logo";
import { useSwipeable } from "react-swipeable";

const Chatarea = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const theme = useTheme();
    const location = useLocation();
    const [searchParams] = useSearchParams()
    const chatEndRef = useRef(null);
    const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));
    const isIpad = useMediaQuery(theme.breakpoints?.down("lg"));
    const xl = useMediaQuery(theme.breakpoints?.down("xl"));
    const { list, loading, details, response } = useSelector((state) => state?.ChatData) || {};
    const [message, setMessage] = useState("");
    const [lastquery, setlastquery] = useState("");
    const [chatmess, setChatmess] = useState([]);
    const [recentList, setRecentList] = useState([]);
    const [stream_upload, setStream_upload] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [checkTypingStatus, setCheckTypingStatus] = useState(true);
    const textBoxRefs = useRef([]);
    const [asynReply, setasynReply] = useState('');
    const [consistencyOutput, setconsistencyOutput] = useState('');
    const [requestContextOutput, setrequestContextOutput] = useState('');
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [switched, setSwitched] = useState(false);
    const { i18n } = useTranslation();

    //handle focus on input
    const handleFocus = (event) => {
        event.preventDefault();
        setIsFocused(false);
    };

    //handle blur on input
    const handleBlur = () => {
        setIsFocused(false);
    };

    // First Load of Page
    useEffect(() => {
        let data = {
            key: "EXT_CLIENT_000025",
            default_lang: i18n.language
        }
        dispatch(getLogo(data));
        dispatch(getLoadingStatus(true));
    }, [switched]);

    // Re-render page on list change
    useEffect(() => {
        textBoxRefs.current.forEach((ref) => {
            if (ref && ref.scrollHeight > ref.clientHeight) {
                ref.classList.add("overflow");
            }
        });
        setCheckTypingStatus(false)
        if (list) {
            setChatmess([...chatmess, { image: require("../assets/w-logo 1@2x.png"), mess: "", reply: list.reply }]);
            setCheckTypingStatus(true)
        }
        
        if (details) {
            let mess = details?.welcome_message?.replace(/\\n/g, '\n')
            setChatmess([{ image: require("../assets/w-logo 1@2x.png"), mess: "", reply: mess }]);
            setStream_upload(details?.stream_enabled)
        }
    }, [list, details]);

    // Re-render page on chatmess change
    useEffect(() => {
        if (chatEndRef.current) {
            const scrollHeight = chatEndRef.current.scrollHeight;
            const clientHeight = chatEndRef.current.clientHeight;
            const scrollToHeight = scrollHeight - clientHeight;
            chatEndRef.current.scrollTo(0, scrollToHeight);
            storage.set.chat(chatmess);
        }
    }, [chatmess]);

    //Reset chat mess on location change
    useEffect(() => {
      setChatmess([])
    }, [location.pathname]);

    // Handle Async Event Stream
    const processAndStoreStream = async (data) => {
        Object.assign(data, { authToken: storage.fetch.chatToken() });
        try {
            const response = await fetch('https://worx-assistant-async-function-app.azurewebsites.net/api/queryAssistantProxyStream', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include', // Ensures cookies and credentials are sent
                body: JSON.stringify(data)
            });
            if (response && response.body && typeof response.body.getReader === 'function') {
                const reader = response.body.getReader();
                const decoder = new TextDecoder("utf-8");
                let done = false;
                let accumulatedReply = ""; // Store all chunks
                let accumulatedReply1 = ""; // Store replies to display
                let stopUpdating = false; // Control when to stop updating the message
                while (!done) {
                    const { value, done: streamDone } = await reader.read();
                    done = streamDone;
                    if (value) {
                        const chunk = decoder.decode(value, { stream: true });
                        accumulatedReply += chunk; // Accumulate full response
                        // Extract `reply` values
                        const matches = chunk.match(/"reply":\s*"([^"]*)"/g);
                        if (matches) {
                            for (const match of matches) {
                                let replyValue = match.replace(/"reply":\s*"([^"]*)"/, '$1');
                                if (!stopUpdating) {
                                    // If the reply is not a control sequence
                                    if (replyValue !== "<<" && replyValue !== "<!" && replyValue !== "<" && replyValue !== "<<!") {
                                        accumulatedReply1 += replyValue;
                                        if (accumulatedReply1) {
                                            let mess = accumulatedReply1?.replace(/\\n/g, '\n')
                                            setChatmess(prevChatmess => {
                                                let updatedChatmess = []
                                                // Create a copy of the current chatmess array
                                                updatedChatmess = [...prevChatmess];
                                                // Check if there are any items in the chatmess array
                                                if (updatedChatmess?.length > 0 && updatedChatmess[updatedChatmess?.length - 1].reply !== "") {
                                                    // Update the last item's reply
                                                    updatedChatmess[updatedChatmess?.length - 1] = {
                                                        image: require("../assets/w-logo 1@2x.png"),
                                                        mess: "",
                                                        reply: mess
                                                    };
                                                } else {
                                                    // If chatmess is empty, add a new entry
                                                    updatedChatmess.push({
                                                        image: require("../assets/w-logo 1@2x.png"),
                                                        mess: "",
                                                        reply: mess
                                                    });
                                                }
                                                // Return the updated array to update the state
                                                return updatedChatmess;
                                            });
                                        }
                                        setasynReply(accumulatedReply1);   // Keep async reply updated
                                        dispatch(getLoadingStatus(false));
                                    } else {
                                        stopUpdating = true; // Stop updating if control sequence is encountered
                                    }
                                }

                                // Handle JSON content between special delimiters
                                let specialDelimiterStart = accumulatedReply.indexOf("<<!");
                                let specialDelimiterEnd = accumulatedReply.indexOf("!>>");

                                if (specialDelimiterStart !== -1 && specialDelimiterEnd !== -1) {
                                    const outputJsonString = accumulatedReply.slice(specialDelimiterStart + 3, specialDelimiterEnd);

                                    try {
                                        const jsonObject = JSON.parse(outputJsonString); // Parse the JSON part
                                        setconsistencyOutput(jsonObject?.consistency_output || "");
                                        setrequestContextOutput(jsonObject?.request_context_output || "");
                                    } catch (parseError) {
                                        console.error('JSON parse error:', parseError, 'at string:', outputJsonString);
                                    }
                                }
                            }
                        }
                    }
                }
                if (done) {
                    //If Stream is completed
                    setCheckTypingStatus(true)
                }
            } else {
                console.error('Response body is not a readable stream or getReader is not a function');
            }
        } catch (error) {
            console.error('Error fetching or processing stream:', error);
        }
    };

    //Send message function
    const handleSendMessage = async () => {
        //Mange history
        const history = storage.fetch.chathistory()
        let hist
        if (history !== undefined) {
            if (history === null) {
                hist = [{
                    "inputs": {
                        "fetched_docs_ids": [],
                        "query": `${lastquery}`
                    },
                    "outputs": {
                        "consistency_output": `${consistencyOutput}`,
                        "reply": `${asynReply}`,
                        "request_context_output": `${requestContextOutput}`
                    }
                }]
                storage.set.chathistory(hist)
                setconsistencyOutput("")
                setrequestContextOutput("")
            } else {
                hist = [...history, {
                    "inputs": {
                        "fetched_docs_ids": [],
                        "query": `${lastquery}`
                    },
                    "outputs": {
                        "consistency_output": `${consistencyOutput}`,
                        "reply": `${asynReply}`,
                        "request_context_output": `${requestContextOutput}`
                    }
                }]
                storage.set.chathistory(hist)
                setconsistencyOutput("")
                setrequestContextOutput("")
            }
        } else {
            hist = [{
                "inputs": {
                    "fetched_docs_ids": [],
                    "query": `ciao`
                },
                "outputs": {
                    "consistency_output": `Greeting - ciao`,
                    "reply": `Ciao! Sono Sporty, il tuo giornalista virtuale di fiducia!`,
                    "request_context_output": `ciao`
                }
            }]
            storage.set.chathistory(null)
        }

        // Define data to send and call function
        if (checkTypingStatus) {
            let data = {
                query: `${message}`,
                chat_history: list?.chat_history ? list?.chat_history : hist,
                fetched_docs_ids: list?.fetched_docs_ids ? list?.fetched_docs_ids : [],
                default_lang: i18n.language
            };
            setlastquery(message)
            setCheckTypingStatus(false)

            // Update Recent history
            setRecentList((prevRecentList) => {
                // Update all items in recentList to set clicked to false
                return prevRecentList.map((item) => {
                    return { ...item, clicked: false };
                });
            });

            if (message.trim() !== "") {
                setChatmess([...chatmess, { image: require("../assets/user.png"), mess: message, reply: "" }]);
                // Update recentList after the state has been updated
                setRecentList((prevRecentList) => {
                    // Create a new array with the new message appended to the beginning
                    const newRecentList = [
                        { image: require("../assets/user.png"), text: message, clicked: true, index: chatmess?.length },
                        ...prevRecentList,
                    ];
                    return newRecentList;
                });

                setMessage(""); // Clear the TextField after sending the message
            }

            // Call API according to stream value
            if (!stream_upload) {
                dispatch(sendmessage(data));
            } else {
                processAndStoreStream(data);
                dispatch(getLoadingStatus(true));
            }
        }

    };

    //Handle send message on enter
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent default form submission
            if (message?.length !== 0) handleSendMessage();
        }
    };

    //Handle clear chat history
    const handleDelete = () => {
        setChatmess([]);
        dispatch(getLogo({ key: "EXT_CLIENT_000025" }));
        setRecentList([]);
        if (isMobile) {
            setDrawerOpen(false)
        }
    };

    //Handle Scroll on select from history
    const handleClick = (index, i) => {
        const targetElement = textBoxRefs.current[index];
        
        if (targetElement) {
            // Get the parent container (you can adjust this based on your container's structure)
            const parentContainer = targetElement.closest('.chatbox'); 
            
            // Manually scroll the parent container to align the target element to the top
            if (parentContainer) {
                parentContainer.scrollTo({
                    top: targetElement.offsetTop - parentContainer.offsetTop, 
                    behavior: 'smooth'
                });
            }
        }
    
        // Update the clicked item in the recent list
        setRecentList((prevRecentList) =>
            prevRecentList.map((item, ind) => ({
                ...item,
                clicked: ind === i,
            }))
        );
    
        if (isMobile) {
            setDrawerOpen(false);
        }
    };
    

    //Style CSS
    const Style = {
        grad: {
            background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
            border: "2px solid",
            borderRadius: "10px",
            borderColor: " #02010100",
            width: "10%",
            minWidth: "950px",
            ml: 2,
            maxWidth: "100%", // Default max width
            height: "fit-content",
        },
        grad1: {
            background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
            border: "2px solid",
            borderRadius: "10px",
            borderColor: " #02010100",
            width: "100%",
            ml: 2,
            maxWidth: "100%", // Default max width
            height: "fit-content",
            wordWrap: "word-break",
            pr: 2,
        },
        overflow: {
            maxWidth: "90%", // Width when overflow occurs
        },
        button: {
            borderRadius: "50%",
            bgcolor: message?.length === 0 ? "#C8C8C8" : "#343568",
            height: { xs: "30px", md: "40px" },
            width: { xs: "30px", md: "40px" },
            "&.MuiButton-root": { minWidth: "30px" },
            "&.MuiButton-root:hover": {
                borderRadius: "50%",
                bgcolor: "#343568",
            },
        },
        input: {
            border: "none",
            bordeRadius: "50px",
            "& .MuiInputBase-root": {
                background: isFocused
                    ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box"
                    : "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                border: isFocused ? "none" : "2px solid",
                bordeRadius: "50px",
                borderColor: " #02010100",
                p: { xs: "10px 10px", md: "15px 15px" }

            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    bordeRadius: "50px",
                    borderColor: "transparent", // Removes the border
                    p: { xs: "10px 10px", md: "auto" }
                },
                "&:hover fieldset": {
                    borderColor: "transparent", // Removes the border on hover
                },
                "&.Mui-focused fieldset": {
                    borderColor: "transparent", // Removes the border when focused
                },
            },
        },
        chatbox: {
            maxHeight: "450px",
            overflow: "scroll",
            mt: 2,
        }
    };

    // To handle Swipe on mobile screen
    const handlers = useSwipeable({
        onSwipedRight: () => {
            setDrawerOpen(true);
        }
    });
    return (
        <div {...handlers}>
            <Grid container>
                <Grid sx={{ width: { xs: "95%", md: "25%" }, display: { xs: 'flex', md: "block" }, justifyContent: "space-between" }}>
                    <Logo />
                    {!isMobile && !isIpad ? <Box
                        sx={{
                            backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                            height: { xs: "calc(100vh - 115px)", md: "calc(100vh - 230px)" },
                            width: "90%",
                            borderRadius: "10px",
                            ml: 2, mb: 2
                        }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "10px" }}>
                            <Typography sx={{ textTransform: "uppercase", color: "#343568", fontSize: { xs: "16px", md: "20px" }, fontWeight: 700 }}>{t('history.title')}</Typography>
                            <IconButton
                                sx={{
                                    border: "1px solid #FF6151",
                                    "&.MuiIconButton-root": {
                                        p: { xs: "3px", md: "5px" },
                                    },
                                }}
                                disabled={recentList?.length === 0 ? true : false}
                                onClick={handleDelete}>
                                <DeleteIcon sx={{ color: "#FF6151", fontSize: { xs: "14px", md: "18px" } }} />
                            </IconButton>
                        </Box>
                        <Box
                            className="chatbox"
                            sx={Style.chatbox}>
                            {recentList?.length === 0 ? (
                                <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                                    <Typography sx={{ fontSize: { xs: "16px", md: "18px" } }}>{t('history.no_data')}</Typography>
                                </Box>
                            ) : (
                                recentList.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            ml: 2,
                                            position: "relative",
                                            mt: 1,
                                            width: "100%",
                                            boxShadow: "1px solid gray",
                                            pr: 0,
                                        }}
                                        style={{ marginLeft: 0, marginTop: "5px" }}>
                                        <Button
                                            sx={{
                                                display: "flex",
                                                justifyContent: "left",
                                                margin: "0px 10px 5px 10px",
                                                boxShadow: "1px 3px 3px 0px #00000026",
                                                bgcolor: "white",
                                                background: item.clicked
                                                    ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box"
                                                    : "linear-gradient(#fff, #fff) padding-box, linear-gradient(#EBEEFF, #EBEEFF) border-box",
                                                border: "2px solid",
                                                bordeRadius: "10px",
                                                borderColor: " #02010100",
                                                p: 1,
                                                width: "100%",
                                                textTransform: "none",

                                                "&.MuiButton-root:hover": {
                                                    background:
                                                        "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                                                    border: "2px solid",
                                                    bordeRadius: "10px",
                                                    borderColor: " #02010100",
                                                },
                                                "&.MuiButton-root:active": {
                                                    background:
                                                        "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                                                    border: "2px solid",
                                                    bordeRadius: "10px",
                                                    borderColor: " #02010100",
                                                },
                                            }}
                                            onClick={() => handleClick(item.index, index)}>
                                            <img src={require("../assets/message.png")} alt="messageImg" />
                                            <Typography sx={{ ml: 1, textAlign: "left", overflow: "hidden", maxWidth: "500px", textOverflow: "ellipsis", color: "#000000", fontSize: { xs: "16px", md: "14px" } }}>
                                                {item.text}
                                            </Typography>
                                        </Button>
                                    </Box>
                                ))
                            )}
                        </Box>
                    </Box> :
                        drawerOpen && (
                            <SwipeableDrawer
                                onClose={() => { setDrawerOpen(false) }}
                                open={drawerOpen}
                            >
                                <Box
                                    sx={{
                                        backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                                        height: { xs: "calc(100vh - 115px)", md: "calc(100vh - 237px)" },
                                        width: "300px",
                                        borderRadius: "10px",
                                    }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", p: "10px" }}>
                                        <Typography sx={{ textTransform: "uppercase", color: "#343568", fontSize: { xs: "16px", md: "20px" }, fontWeight: 700 }}>{t('history.title')}</Typography>
                                        <IconButton
                                            sx={{
                                                border: "1px solid #FF6151",
                                                "&.MuiIconButton-root": {
                                                    p: { xs: "3px", md: "5px" },
                                                },
                                            }}
                                            disabled={recentList?.length === 0 ? true : false}
                                            onClick={handleDelete}>
                                            <DeleteIcon sx={{ color: "#FF6151", fontSize: { xs: "14px", md: "18px" } }} />
                                        </IconButton>
                                    </Box>
                                    <Box
                                        className="chatbox"
                                        sx={Style.chatbox}>
                                        {recentList?.length === 0 ? (
                                            <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                                                <Typography sx={{ fontSize: { xs: "16px", md: "18px" } }}>{t('history.no_data')}</Typography>
                                            </Box>
                                        ) : (
                                            recentList?.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: "flex",
                                                        ml: 2,
                                                        position: "relative",
                                                        mt: 1,
                                                        width: "100%",
                                                        boxShadow: "1px solid gray",
                                                        pr: 0
                                                    }}
                                                    style={{ marginLeft: 0, marginTop: "5px" }}>
                                                    <Button
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "left",
                                                            margin: "0px 10px 5px 10px",
                                                            boxShadow: "1px 3px 3px 0px #00000026",
                                                            bgcolor: "white",
                                                            background: item.clicked
                                                                ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box"
                                                                : "linear-gradient(#fff, #fff) padding-box, linear-gradient(#EBEEFF, #EBEEFF) border-box",
                                                            border: "2px solid",
                                                            bordeRadius: "10px",
                                                            borderColor: " #02010100",
                                                            p: 1,
                                                            width: "100%",
                                                            textTransform: "none",

                                                            "&.MuiButton-root:hover": {
                                                                background:
                                                                    "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                                                                border: "2px solid",
                                                                bordeRadius: "10px",
                                                                borderColor: " #02010100",
                                                            },
                                                            "&.MuiButton-root:active": {
                                                                background:
                                                                    "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                                                                border: "2px solid",
                                                                bordeRadius: "10px",
                                                                borderColor: " #02010100",
                                                            },
                                                        }}
                                                        onClick={() => handleClick(item.index, index)}>
                                                        <img src={require("../assets/message.png")} alt="messageImg" />
                                                        <Typography sx={{ ml: 1, textAlign: "left", overflow: "hidden", maxWidth: "500px", textOverflow: "ellipsis", color: "#000000", fontSize: { xs: "16px", md: "14px" } }}>
                                                            {item.text}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            ))
                                        )}
                                    </Box>
                                </Box>
                            </SwipeableDrawer>
                        )
                    }
                    {isMobile && <LanguageSwitcher switched={switched} setSwitched={setSwitched} setChatmess={setChatmess} setRecentList={setRecentList} />
                    }
                </Grid>
                {
                    "EXT_CLIENT_000025" === null || "EXT_CLIENT_000025" === undefined || "EXT_CLIENT_000025" === "" || details === "Client not found" ?
                        <>
                            <Box sx={{
                                height: "10%",
                                width: isMobile || isIpad ? "100%" : "calc(100% - 390px)",
                                borderRadius: "10px",
                                p: { xs: 0, sm: 2 },
                            }}>
                                {!isMobile && <LanguageSwitcher switched={switched} setSwitched={setSwitched} setChatmess={setChatmess} setRecentList={setRecentList} />}
                                <Box
                                    sx={{
                                        backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                                        borderRadius: "20px",
                                        // width: "95%",
                                        minHeight: "450px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                    <Typography sx={{ fontSize: "30px" }} component={"h1"}>{t('error.client_id_not_found')}</Typography>
                                </Box>
                            </Box>
                        </>
                        :
                        <>
                            <Box
                                sx={{

                                    width: isMobile || isIpad ? "100%" : "calc(100% - 26%)",
                                    borderRadius: "10px",
                                    p: { xs: 2, sm: 0 },
                                    ml: "0px",
                                }}>
                                {!isMobile && <LanguageSwitcher switched={switched} setSwitched={setSwitched} setChatmess={setChatmess} setRecentList={setRecentList} />}
                                <Box
                                    sx={{
                                        backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                                        borderRadius: "20px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        p: 2,
                                        m: { xs: 0,sm:2,md:2, lg: 0 },
                                    }}>
                                    <Box
                                        className="chatbox"
                                        sx={{
                                            overflow: "scroll",
                                            height: { xs: "calc(90vh - 245px)", sm: "calc(100vh - 295px)" },
                                        
                                        }}
                                        ref={chatEndRef}>
                                        <>
                                            {chatmess.map((item, index) => (
                                                <Box sx={{ display: "flex", height: "auto", mt: 2 }} key={index}>
                                                    <Box
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: "50%",
                                                            width: item.reply !== "" ? { xs: "40px", md: "50px" } : { xs: "40px", sm: "40px", md: "50px" },
                                                            height: item.reply !== "" ? { xs: "40px", md: "50px" } : { xs: "40px", md: "50px" },
                                                            p: item.reply !== "" ? isMobile || isIpad ? 1.2 : 1.4 : 0.6,
                                                            pt: item.reply !== "" ? { xs: 1.4, md: 1.5 } : 0.6
                                                        }}>
                                                        <img
                                                            style={{ width: item.reply !== "" ? isMobile || isIpad ? "22px" : "30px" : isMobile || isIpad ? "30px" : "40px", height: item.reply !== "" ? isMobile || isIpad ? "20px" : "30px" : isMobile || isIpad ? "30px" : "40px", }}
                                                            src={item.image}
                                                            alt="w-logo"
                                                        />
                                                    </Box>
                                                    {item.reply !== "" ? (
                                                        <Box ref={(el) => (textBoxRefs.current[index] = el)} sx={{ ...Style.grad1, wordBreak: "break-word" }}>
                                                            <Box sx={{ ml: 1, mt: 1.5, mb: 1.5, fontSize: { xs: "14px", md: "1rem" } }}>
                                                                <TypingText text={item.reply} index={index} chatEndRef={chatEndRef} setCheckTypingStatus={setCheckTypingStatus} checkTypingStatus={checkTypingStatus} />
                                                            </Box>
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            <Box ref={(el) => (textBoxRefs.current[index] = el)} id={index} className="scroll-to" sx={{ ...Style.grad1, wordBreak: "break-word" }}>
                                                                <Typography sx={{ ml: 1, mt: 1.5, mb: 1.5, fontSize: { xs: "14px", md: "1rem" } }}>{item.mess}</Typography>
                                                            </Box>
                                                        </>
                                                    )}
                                                </Box>
                                                // {/* ))*/} 
                                            ))}
                                            {loading && (
                                                <Box sx={{ display: "flex", height: "auto", mt: 2 }}>
                                                    <Box sx={{
                                                        bgcolor: "white", borderRadius: "50%", width: { xs: "40px", md: "50px" }, height: { xs: '40px', md: "50px" }, p: isMobile || isIpad ? 1.2 : 1.4,
                                                        pt: { xs: 1.4, md: 1.5 }
                                                    }}>
                                                        <img style={{ width: isMobile || isIpad ? "22px" : "30px", height: isMobile || isIpad ? "20px" : "30px" }}
                                                            src={require("../assets/w-logo 1@2x.png")} alt="W-logo" />
                                                    </Box>
                                                    <Box sx={Style.grad1}>
                                                        <Box sx={{ display: "flex", wordBreak: "break-all", justifyContent: "space-evenly", width: { xs: '70%', md: "20% " } }}>
                                                            <Typography sx={{ mt: 1.4, mb: 1.4, fontSize: { xs: "14px", md: "1rem" }, color: "gray" }}>{t('assistant.loading')}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )}
                                            {
                                                loading !== undefined ? null : <Box sx={{ display: "flex", height: "auto", mt: 2 }}>
                                                    <Box sx={{
                                                        bgcolor: "white", borderRadius: "50%", width: "50px", height: "50px", p: isMobile || isIpad ? 1.2 : 1.4,
                                                        pt: { xs: 1.4, md: 1.5 }
                                                    }}>
                                                        <img style={{ width: isMobile || isIpad ? "22px" : "30px", height: isMobile || isIpad ? "20px" : "30px" }}
                                                            src={require("../assets/w-logo 1@2x.png")} alt="W-logo" />
                                                    </Box>
                                                    <Box sx={Style.grad1}>
                                                        <Box sx={{ display: "flex", wordBreak: "break-all", justifyContent: "space-evenly", width: { xs: '50%', md: "20% " } }}>
                                                            <Typography sx={{ mt: 1.4, mb: 1.4, fontSize: { xs: "14px", md: "1rem" }, color: "gray" }}>{t('assistant.loading')}
                                                            </Typography>                          </Box>
                                                    </Box>
                                                </Box>
                                            }
                                        </>
                                    </Box>
                                    <Box>
                                        <TextField
                                            autoFocus
                                            fullWidth
                                            multiline
                                            maxRows={5}
                                            placeholder={t('input.field')}
                                            onChange={(e) => setMessage(e.target.value)}
                                            value={message}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            onKeyDown={handleKeyDown} // Attach keydown event listener
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Button disabled={message?.length === 0 ? true : false} sx={Style.button} onClick={handleSendMessage}>
                                                            <FontAwesomeIcon icon={["far", "paper-plane"]} color="white" style={{ marginRight: "2px" }} />
                                                        </Button>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            sx={Style.input}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </>
                }
            </Grid>
        </div>
    );
};

export default Chatarea;
